module.exports = __webpack_public_path__ + "static/img/241_phase_function_Paper_Points.9217496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/241_phase_function_Paper_Points.png
// module id = Y9Oq
// module chunks = 0